import { hbs } from 'ember-cli-htmlbars';
export default hbs("<path\n  class=\'chart-line\'\n  d={{@svgPathD}}\n  fill=\'none\'\n  style={{layout-css-var line-color=@color}}\n  data-test-chart-line\n  ...attributes\n></path>")